<template>
  <div class="wrapper-card-media">
    <div class="wrapper-media-top image-with-shadow image-with-background">
      <LazyHydrate never>
        <LadImage
          :src="item.media.data.url"
          :max-width="500"
          :min-height="300"
          :quality="85"
          :alt="item.name || item.title"
        />
      </LazyHydrate>
    </div>

    <div v-if="hasName" class="wrapper-card-name">
      <!-- cities, categories -->
      <div class="d--table">
        <div>
          <h4>{{ item.name }}</h4>
        </div>
      </div>
    </div>
    <div v-else-if="isProduct" class="wrapper-experience-name">
      <!-- experiences, packages -->
      <h5 class="title">{{ item.title }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadMediaCard',
  props: {
    item: { type: Object, required: true },
    isProduct: { type: Boolean, required: true },
  },
  computed: {
    hasName() {
      return Reflect.has(this.item, 'name')
    },
  },
}
</script>

<style lang="scss">
$font-size: 1em;
$line-height: 1.5;
$lines-to-show: 2;

.wrapper-card-media {
  position: relative;

  .wrapper-media-top {
    overflow: hidden;
  }

  .lad-image {
    img {
      transition: all 0.3s ease;
      object-fit: cover;
      height: 100% !important;
    }
  }

  .title {
    color: #212223;
    font-size: 1em;
    line-height: 1.5;
    margin: 15px 0;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 0;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines-to-show; /* Fallback for non-webkit */
    overflow: hidden;
    -webkit-line-clamp: $lines-to-show;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  &:hover {
    img {
      transform: scale(1.1, 1.1);
    }
  }
}
</style>
